<template>
  <div class="hr-card" @click="click">
    <div class="hr-card-container">
      <div v-if="$slots.header" class="hr-card__header">
        <slot name="header"></slot>
      </div>
      <div class="hr-card__body">
        <slot></slot>
      </div>
    </div>
    <div v-if="$slots.helper" class="hr-card__helper">
      <slot name="helper"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hr-card',
  setup(props, { emit }) {
    function click() {
      emit('click');
    }
    return {
      click,
    };
  },
};
</script>

<style scoped>
.hr-card {
  display: flex;
  flex-direction: column;
}

.hr-card-container {
  border: none;
  border-radius: 8px;
  background: var(--co-background-secondary);
}

.hr-card__header {
  padding: 15px;
  text-align: center;
}

.hr-card__body {
  padding: 30px;
  flex-direction: column;
}

.hr-card__helper {
  padding-top: 5px;
}
</style>
